import { Button, styled } from '@mui/material';

const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: '40px',
  marginLeft: '0 !important',
  minWidth: '130px',
  fontWeight: 600,
  textTransform: 'uppercase',
  boxShadow: 'none',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export default ActionButton;
